import { render, staticRenderFns } from "./ImportSimplify.vue?vue&type=template&id=13da896a"
import script from "./ImportSimplify.vue?vue&type=script&lang=js"
export * from "./ImportSimplify.vue?vue&type=script&lang=js"
import style0 from "./ImportSimplify.vue?vue&type=style&index=0&id=13da896a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports